import type {
    SurgicalGuideCaseSettingsApiObject,
    SurgicalGuideUserPreferencesApiObject,
    UpdateSurgicalGuideCaseSettingsRequest,
    UpdateSurgicalGuideUserPreferencesRequest,
} from '@/api/surgicalGuide/types';
import type { SurgicalGuideCaseData, SurgicalGuideUserPreferenceData } from '@/stores/surgicalGuide/surgicalGuide.types';
import { isIntString } from '@/util/isIntString';

export function apiToState(apiData: SurgicalGuideCaseSettingsApiObject): SurgicalGuideCaseData {
    const surgicalApproachId = apiData.surgical_approach_id?.toString() || '';

    return {
        crNumber: apiData.cr_number || '',
        surgicalApproachId: surgicalApproachId && isIntString(surgicalApproachId) ? surgicalApproachId : '',
    };
}

export function stateToRequest(state: SurgicalGuideCaseData, includeCrNumber: boolean = false): UpdateSurgicalGuideCaseSettingsRequest {
    const request: UpdateSurgicalGuideCaseSettingsRequest = {
        surgical_approach_id: state.surgicalApproachId && isIntString(state.surgicalApproachId)
            ? parseInt(state.surgicalApproachId, 10)
            : null,
    };

    if (includeCrNumber) {
        request.cr_number = state.crNumber || '';
    }

    return request;
}

export function caseSettingsToState(
    surgeonPreferences: SurgicalGuideUserPreferencesApiObject,
    preserveCrNumber?: string,
): SurgicalGuideCaseData {
    return {
        crNumber: preserveCrNumber || '',
        surgicalApproachId: surgeonPreferences.surgical_approach_id?.toString() || '',
    };
}

export function surgeonPreferencesToState(apiData: SurgicalGuideUserPreferencesApiObject): SurgicalGuideUserPreferenceData {
    return {
        surgicalApproachId: apiData.surgical_approach_id?.toString() || '',
    };
}

export function userStateToRequest(state: SurgicalGuideUserPreferenceData): UpdateSurgicalGuideUserPreferencesRequest {
    return {
        surgical_approach_id: state.surgicalApproachId ? parseInt(state.surgicalApproachId) : null,
    };
}
